import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";


export const DEIPageFullTeamRaceSECTION = styled.section`
  padding: 80px 0;
  
  ${MEDIA_QUERIES.M} {
    overflow: hidden;
  }
`;

export const DEIPageFullTeamRaceGridDIV = styled.div.attrs({ className: "grid" })`
  flex-direction: row-reverse;
  justify-content: flex-end;

  > h3 {
    margin: 0 auto 20px;
    text-align: center;

    ${MEDIA_QUERIES.M} {
      display: none;
    }
  }

  > div.column {
    align-self: center;
  }
`;


export const DEIPageFullTeamRaceContentDIV = styled.div`
  text-align: center;
  margin-bottom: var(--spacing--L);
`

export const DEIPageFullTeamRaceLegendDIV = styled.div`
  h3 {
    display: none;
  }

  ${MEDIA_QUERIES.M} {
    h3 {
      display: block;
    }
  }
`;

export const DEIPageFullTeamRaceChartDIV = styled.div`
  canvas {
    width: 100%;
    max-width: 750px;
    margin-bottom: 30px;

    ${MEDIA_QUERIES.M} {
      margin: 0 -40px;
      width: calc(100% + 80px);
    }

    ${MEDIA_QUERIES.XL} {
      margin: 0 -60px 0 -40px;
      width: calc(100% + 100px);
    }
  }
`;
